export default __webpack_public_path__ + "static/media/whatsapp.ea9ad74f.png";